<template>
	<div class="bcgl">
		<div style="margin: 0rem 0 0 0rem; border: 1px #DDDDDD solid;">
			<el-card class="box-card">
				<div slot="header">
					<el-row style="margin-bottom: 20px">
						<el-col :span="24">
							<div style="line-height: 3rem; font-size: 1.5rem;">新进人员装备统计</div>
						</el-col>

					</el-row>
					<el-row style="text-align: left">
						<el-form :inline="true" :model="searchForm" @keyup.enter.native="searchData()">
							<el-form-item  >
								<el-select  @change="getConfigDetail" style="width: 200px" v-model="searchForm.configId" filterable clearable placeholder="请选择装备配置">
									<el-option

											v-for="item in equipConfigs"
											:key="item.id"
											:label="item.name"
											:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item  >
							<el-select  v-model="searchForm.typeId" filterable clearable placeholder="请选择装备">
								<el-option
										v-for="item in types"
										:key="item.id"
										:label="item.name"
										:value="item.id">
								</el-option>
							</el-select>
							</el-form-item>
							<el-form-item >
								<el-select   clearable :disabled="deptdisable"  filterable   v-model="searchForm.bmid"  placeholder="请选择部门">
									<el-option
											v-for="item in depts"
											:key="item.bmid"
											:label="item.bmmc"
											:value="item.bmid"
											:disabled="deptdisable">
									</el-option>
								</el-select>
							</el-form-item>

							<el-form-item>
								<el-button type="primary" @click="searchData2()">查询</el-button>
								<el-button type="primary" @click="exportExcel()">导出</el-button>
								<el-button type="primary" @click="dialogVisible = true">提交审批</el-button>
<!--								<el-button v-if="isAuth('equipContract:add')" type="primary" @click="addOrUpdate()"  style="display: inline;">出库</el-button>-->
							</el-form-item>
						</el-form>
					</el-row>
				</div>
				<el-container>
					<el-main width ="100%" >

							<el-table border
									:data="contractList" v-loading="loading" :row-key="getRowKeys" style="text-align: center; width: 100%;"
									:span-method="objectSpanMethod"
									:header-cell-style="{color:'black',borderColor:'black'}"
									:cell-style="cellStyle">


								<el-table-column  label="序号"   prop="index">
									<template slot-scope="scope">
										{{scope.$index+1}}
									</template>
								</el-table-column>
								<el-table-column  label="部门"   prop="dept">
								</el-table-column>
								<el-table-column  label="装备类型"   prop="name">
								</el-table-column>
								<el-table-column  label="规格"   prop="specification">
								</el-table-column>
								<el-table-column  label="尺寸" show-overflow-tooltip  prop="equipSize">

								</el-table-column>

								<el-table-column  label="数量"   prop="num" >

								</el-table-column>
								<el-table-column  label="单价"   prop="price">

								</el-table-column>
								<el-table-column  label="价格"   prop="total">

								</el-table-column>
								<!--<el-table-column  label="导出"   prop="" :render-header="renderHeader">

								</el-table-column>-->
							</el-table>


					</el-main>
				</el-container>

			</el-card>
			<!--测试弹窗-->
			<el-dialog
					title="提交审批"
					:visible.sync="dialogVisible"
					width="30%"
					:before-close="handleClose">
                <div>
                    <el-form ref="form" :model="form" label-width="80px">
                        <el-form-item label="标题">
                            <el-input v-model="form.title"></el-input>
                        </el-form-item>
                        <el-form-item label="备注">
                            <el-input
                                    type="textarea"
                                    :rows="3"
                                    placeholder="请输入内容"
                                    v-model="form.remarks">
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="commitData()">确 定</el-button>
                            <el-button @click="dialogVisible = false">取 消</el-button>
                        </el-form-item>
                    </el-form>
                </div>
				<span slot="footer" class="dialog-footer">

  </span>
			</el-dialog>
		</div>
		<add-or-update v-if="customerVisible" ref="customer" @refreshDataList="searchData"></add-or-update>
		<out-log v-if="showInfoVisible" ref="showInfo"></out-log>
		<form ref="exportForm1" method="post" :action="this.$request.defaults.baseURL+'/bjba/newuserEquip/exportExcel?access_token='+this.$store.getters.token"  target="_blank">
			<input type="hidden" v-for="(value,key,index) in searchForm" :name="key"  :value="value" />
		</form>
	</div>

</template>
<script >
	import {
		Vue,
		Component
	} from 'vue-property-decorator'
	import AddOrUpdate from './equip-out'
	import OutLog from './detail-out-log3'
	const exportFields=[
		{value:"name",name:"名称"},
		{value:"num",name:"数量"},
		{value:"dept",name:"部门"},
		{value:"gw",name:"岗位"},
		{value:"type",name:"类型"},
		{value:"specification",name:"规格"},
		{value:"unit",name:"单位"},
		{value:"equipSize",name:"尺寸"}

	]
	@Component({
		name: 'contractinfo',
		components:{
			AddOrUpdate,
			OutLog
		}
	})

	export default class contractinfo extends Vue {
		customerVisible=false
		currentNo = 1;
		pageSize= 10;
		pageTotal = 0;

		activeNames=[];
		showbmxxVisible= false;
		customerList=[]
		equipConfigs=[]
		showfileVisible=false
		showInfoVisible=false
		types=[]
		searchForm= {
			configId: '',
			bmid:'',
			xm:'',
			typeId:''
		}
		depts=[]
		deptdisable=false
		startTime=[]
		amount=['','']
		contractList=[]
		contractList1=[]
		loading = false;
		loading1 = false;
		dataListSelections=[];
		sjbm=[]
		selectBm=''
		isIndeterminate=false
		exportVisible=false
		checkAll=false
		fields=exportFields
		filedValues=exportFields.map(item => item.value)
		fieldList=[]
		isIndeterminate1=false
		exportVisible1=false
		checkAll1=false
		fieldList1=[]
        dialogVisible = false
        form={
		    title:'',
            remarks:''
        }

		created() {
			this.getTypes()
			this.getEquipConfigs()
			this.getDepts()
			this.searchData();
		}



		searchData2() {
			this.searchData();
			// this.searchData1();
		}

		getConfigDetail() {
			this.searchForm.typeId = ''
			this.types = []
			if (this.searchForm.configId) {
				this.$http({
					url: '/bjba/equip/config/details/'+this.searchForm.configId,
					method: 'get'
				}).then(({data}) => {
					this.types = data.data
				})
			} else {
				this.getTypes()
			}
		}


		getRowKeys(row) {
			return row.id;
		}
		showInfo(row){

			this.showInfoVisible = true
			this.$nextTick(() => {
				this.$refs.showInfo.init(row)
			})
		}
		searchData() {
			this.loading = true;
			this.$request({
					url: '/bjba/newuserEquip/findStatistics',
					method: 'get',
					params: this.searchForm
				})
				.then(response => {
					this.loading = false;
					let data = response.data;
					if (data.code == 200) {

						//合并单元格
						let dataSolve = this.mergeTableRow(data.data.data, ["dept"])
						this.contractList = data.data.data;
						this.pageTotal = data.data.count
					} else {
						this.$message.error(data.message)
					}
				})
				.catch(error => {
					this.loading = false;
					console.log(error)
					this.$message.error(error)
				});
		}

		/**
		 * 合并单元格
		 * @param data 数据
		 * @param merge 要合并的列
		 * @returns {*}
		 */
		mergeTableRow(data, merge) {
			if (!merge || merge.length === 0) {
				return data;
			}
			merge.forEach((m) => {
				const mList = {};
				data = data.map((v, index) => {
					const rowVal = v[m];
					if (mList[rowVal] && mList[rowVal].newIndex === index) {
						mList[rowVal]["num"]++;
						mList[rowVal]["newIndex"]++;
						data[mList[rowVal]["index"]][m + "-span"].rowspan++;
						v[m + "-span"] = {
							rowspan: 0,
							colspan: 0,
						};
					} else {
						mList[rowVal] = {
							num: 1,
							index: index,
							newIndex: index + 1,
						};
						v[m + "-span"] = {
							rowspan: 1,
							colspan: 1,
						};
					}
					return v;
				});
			});
			return data;
		}

		/**
		 * 合并列实现方法 绑定
		 * @param row
		 * @param column
		 * @param rowIndex
		 * @param columnIndex
		 * @returns {*}
		 */
		objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			const span = column["property"] + "-span";
			if (row[span]) {
				return row[span];
			}
		}
		cellStyle({row, column, rowIndex, columnIndex}) {
			return 'height:35px!important; border-color:black!important; color:#000000!important; padding:0px!important; height:40px!important'
		}

		exportExcel() {
			this.$refs.exportForm1.submit();
		}

		handleClose(done) {
			this.$confirm('确认关闭？')
					.then(_ => {
						done();
					})
					.catch(_ => {});
		}
		/**
		 * 提交审批
		 */
		commitData(){
			this.loading = true;
			this.form
			this.$request({
				url: '/bjba/newuserEquip/commitData',
				method: 'post',
				params: {title:this.form.title,
						remarks:this.form.remarks,
						typeId:this.searchForm.typeId,
						configId:this.searchForm.configId,
						bmid:this.searchForm.bmid
				}

			}).then(response => {
						this.loading = false;
						let data = response.data;
						if (data.code == 200) {
							this.$message.info("提交成功")
							this.dialogVisible = false
						} else {
							this.$message.error(data.message)
						}
					}).catch(error => {
						this.loading = false;
						console.log(error)
						this.$message.error("提交出错")
					});
		}

		getTypes() {
			this.$request.get('/bjba/equip/type/getAll').then(res => {

				this.types = res.data.data;
			})
		}
		getEquipConfigs() {
			this.$request.get('/bjba/equip/config/getAll').then(res => {

				this.equipConfigs = res.data.data;
			})
		}
		getDepts() {
			let that = this;
			this.$request.get('/bjba/kqtj/getFirstMentForUser',{
				params: {
					userid:this.$store.getters.username
				}

			}).then(res => {
				that.depts = res.data
			})
		}
		getTypeName(typeid){
			var typeName =""
			if(typeid){
				for(var i=0;i<this.types.length;i++) {
					if (typeid == this.types[i].id) {
						typeName = this.types[i].name
						break
					}
				}
				return typeName
			}
			return typeName
		}
	}
</script>
<style lang="scss" scoped>
	.bcgl {}
	.el-table td, .el-table th.is-leaf,.el-table--border, .el-table--group{
		border-color: black;
	}
	.el-table--border::after, .el-table--group::after, .el-table::before{
		background-color: black;
	}
</style>
